import { useQuery } from 'react-query';
import { UseSubUsersENTOptions } from './useSubUsersENT.types';
import { subUsersENTQuery } from './useSubUsersENT.query';
import { SubUser } from '../../../types/models/user/user.types';

export const SUB_USERS_ENT_QUERY_KEY = 'SUB_USERS_ENT';

export const useSubUsersENT = (options?: UseSubUsersENTOptions) => {
  return useQuery<SubUser[], Error>(
    SUB_USERS_ENT_QUERY_KEY,
    () => subUsersENTQuery(),
    options
  );
};
